module.exports = __webpack_public_path__ + "media/images/tools-home-b81019382730c9925853cc87e8119a41.svg";